export class ParentescoPosRecadDTO {
    recadValidacaoParentescoId: number;
    listaSrh: ParentescoSrh[];
    listaRecad: ParentescoRecad[];

}

class ParentescoSrh {
    recadValidacaoParentescoId: number;
    descricaoGrauParentesco: string;
    nomeParentesco: string;
}

class ParentescoRecad {
    recadValidacaoParentescoId: number;
    descricaoGrauParentesco: string;
    nomeParentesco: string;
}
